import Mock from 'mockjs'

const {page, save} = require('../util');
const {models} = require('./data');
const qs = require('qs');

Mock.mock('/model/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(models, bodyObject);
    bodyObject.total = models.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/model/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, models);
    return {
        code: 200,
        body: models,
    }
});
